var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 18,
    viewBox: "0 0 12 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.99984 8.58341C5.4473 8.58341 4.9174 8.36392 4.5267 7.97322C4.136 7.58252 3.9165 7.05262 3.9165 6.50008C3.9165 5.94755 4.136 5.41764 4.5267 5.02694C4.9174 4.63624 5.4473 4.41675 5.99984 4.41675C6.55237 4.41675 7.08228 4.63624 7.47298 5.02694C7.86368 5.41764 8.08317 5.94755 8.08317 6.50008C8.08317 6.77367 8.02928 7.04458 7.92459 7.29734C7.81989 7.5501 7.66643 7.77977 7.47298 7.97322C7.27952 8.16668 7.04986 8.32013 6.79709 8.42483C6.54433 8.52953 6.27342 8.58341 5.99984 8.58341ZM5.99984 0.666748C4.45274 0.666748 2.96901 1.28133 1.87505 2.37529C0.781085 3.46925 0.166504 4.95299 0.166504 6.50008C0.166504 10.8751 5.99984 17.3334 5.99984 17.3334C5.99984 17.3334 11.8332 10.8751 11.8332 6.50008C11.8332 4.95299 11.2186 3.46925 10.1246 2.37529C9.03066 1.28133 7.54693 0.666748 5.99984 0.666748Z",
    fill: "#C7222A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.0a15b4958ebdf53a4506270cbcf45b94.svg";
export { ForwardRef as ReactComponent };